import DownArrow from '../../../components/svg/down-arrow'
import Location from '../../../components/svg/location'

export default function LocationFilterHandle({ name, zipCode, onClick }) {
  return (
    <div className='wrapper'>
      <label className='handle flex alignCenter'>
        <Location className='locationSvg' />
        <span>Search Radius</span>
        <button aria-label='Set postal code' className='flatBtn' onClick={() => onClick(name)}>
          <span>{zipCode}</span>
          <DownArrow className='arrowSvg' />
        </button>
      </label>

      <style jsx>{`
        .wrapper {
          display: inline-block;
        }

        .handle {
          color: var(--primary-bg-color);
          font-weight: 700;
          font-size: 1.8rem;

          :global(.locationSvg) {
            width: 1.3rem;
            height: 1.8rem;
            margin: 0 1.3rem 0 0;
            fill: var(--primary-bg-color);
          }

          button {
            position: relative;
            width: 8.8rem;
            height: 2.5rem;
            margin: 0 0 0 1.3rem;
            text-align: left;
            color: var(--primary-color);

            :global(.arrowSvg) {
              position: absolute;
              top: 50%;
              right: 0;
              transform: translate(0, -50%);
              width: 1.2rem;
              height: 0.6rem;
            }
          }
        }

        @media (max-width: 1024px) {
          .handle {
            font-size: 1.2rem;

            :global(.locationSvg) {
              width: 1rem;
              height: 1.3rem;
              margin: 0 0.4rem 0 0;
            }

            button {
              width: 5.5rem;
              margin: 0 0 0 0.4rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
